import { change } from 'redux-form';
import { CHECKOUT_FORM_NAME } from '../constants';
import { SEND_EMAIL_TO_ATTENDEES_FIELD } from '../containers/checkout/constants';
import { isAddAttendeesOrder } from '../selectors/order/typedOrderSelectors';

export const initializeSendEmailToAttendees = () => (dispatch, getState) => {
    const state = getState();
    const shouldInitializeSendEmailToAttendees = isAddAttendeesOrder(state);

    if (!shouldInitializeSendEmailToAttendees) {
        return;
    }

    dispatch(change(CHECKOUT_FORM_NAME, SEND_EMAIL_TO_ATTENDEES_FIELD, true));
};
